<template>
    <aside class="d-flex flex-column overflow-visible;" :class="[{'collapsed':!isHoveringMenu}, environment]" @mouseenter="mouseenter" @mouseleave="mouseleave">
        <nav role="navigation" class="flexGrow1">
            <router-link class="logo" :to="{ name: 'dashboard'}">
                <div class="logoCanvas">
                    <img class="logoBig" src="../../assets/images/logo.svg" alt="Pluralo">
                </div>
                <img class="logoSmall" src="/static/images/common/logo_small_red_white.svg" alt="Pluralo">
            </router-link>
            <ul>
                <li v-for="(link, index) in linksNew" :key="index" v-if="showThisLink(link)" class="position-relative no-break-label">
                    <router-link exact active-class="active" :to="{ name: link.linkTo }">
                        <span class="selection"></span>
                        <span class="fs-larger position-relative">
                            <i :class="link.icon"></i>
                            <span class="newItemLabel fs-smallest bg-color-1" v-if="showNewLabel(link)">New</span>
                        </span>
                        <span class="label">{{ link.label }}</span>
                    </router-link>
                </li>
            </ul>
        </nav>

        <div class="bottomInfoBig darker p-2">
            <span @click="reloadApp" class="pointer"><i class="ico ico-reshedule fs-normal"></i> {{version}} - </span>
            <span class="fs-smaller darker">{{getUserAccessType.label}}</span>
        </div>

        <div class="bottomInfoSmall darker p-2 text-center">
            <span>{{version}}</span>
        </div>
    </aside>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        data() {
            return {
                testeMyAccess: 1,
                isHoveringMenu: false,
                linksNew: [
                    {
                        label: 'Home',
                        linkTo: 'dashboard',
                        icon: 'fas fa-home',
                        allowedToAccess: ['admin','basic','restricted','supervisor']
                    },
                    {
                        label: 'Calendar',
                        linkTo: 'calendar',
                        icon: 'far fa-calendar-alt',
                        allowedToAccess: ['admin','basic','restricted','supervisor', 'viewer']
                    },
                    {
                        label: 'Reservations',
                        linkTo: 'reservations',
                        icon: 'fas fa-clipboard-check',
                        allowedToAccess: ['admin','basic','restricted','supervisor']
                    },
                    {
                        label: 'Agents',
                        linkTo: 'agents',
                        icon: 'fas fa-users',
                        allowedToAccess: ['admin','supervisor']
                    },
                    {
                        label: 'My inventory',
                        linkTo: 'inventory',
                        icon: 'fas fa-shapes',
                        allowedToAccess: ['admin']
                    },
                    {
                        label: 'Invoices',
                        linkTo: 'invoices',
                        icon: 'fas fa-file-invoice-dollar',
                        allowedToAccess: ['admin','supervisor'],
                        enabled: this.showInvoiceOption,
                    },
                    {
                        label: 'Reports',
                        linkTo: 'reports',
                        icon: 'far fa-chart-bar',
                        allowedToAccess: ['admin','supervisor']
                    },
                    {
                        label: 'Pricing Rules',
                        linkTo: 'rules',
                        icon: 'fas fa-chart-line',
                        allowedToAccess: ['admin','supervisor']
                    },
                    {
                        label: 'Promocodes',
                        linkTo: 'promocodes',
                        icon: 'fas fa-bullhorn',
                        allowedToAccess: ['admin','supervisor'],
                        newLabel: {
                            until: '2019-04-30'
                        }
                    },
                    {
                        label: 'Schedule Tasks',
                        linkTo: 'scheduleTasks',
                        icon: 'fas fa-business-time',
                        allowedToAccess: ['admin','supervisor'],
                        enabled: () => this.featureFlags.showShceduleTasks,
                        newLabel: {
                            until: '2020-04-30'
                        }
                    },
                    {
                        label: 'Settings',
                        linkTo: 'settings',
                        icon: 'fas fa-cog',
                        allowedToAccess: ['admin'],
                    },
                ],
            }
        },
        computed:{
            ...mapGetters([
                'account',
                'getUserAccessType',
                'getShowInvoiceOption',
            ]),
            version() {
                return process.env.CURRENT_VERSION;
            },
            environment() {
                return process.env.NODE_ENV;
            },
        },
        methods: {
            reloadApp() {
                location.reload(true);
            },
            showNewLabel(item) {
                if (!item.newLabel) {
                    return false;
                }

                return moment().isBefore(item.newLabel.until);
            },
            showThisLink(link) {
                let doIHavePermissions = this.accessPermissionFilter(link.allowedToAccess);
                
                if (!link.enabled) {
                    return doIHavePermissions;
                } else {
                    return doIHavePermissions && link.enabled();
                }
            },
            mouseenter(e) {
                this.isHoveringMenu = true;

                if (document.querySelector('#intercom-container .intercom-app .intercom-launcher-frame')) {
                    document.querySelector('#intercom-container .intercom-app .intercom-launcher-frame').classList.add("big");
                }
            },
            mouseleave() {
                this.isHoveringMenu = false;

                if (document.querySelector('#intercom-container .intercom-app .intercom-launcher-frame')) {
                    document.querySelector('#intercom-container .intercom-app .intercom-launcher-frame').classList.remove("big");
                }
            },
            showInvoiceOption() {
                return this.getShowInvoiceOption ? this.getShowInvoiceOption : false;
            },
        }
    }
</script>
<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';
    @import '~@/assets/scss/_typography.scss';

    aside {
        transition: all 300ms ease-in-out;
        color: $lightest;
        background: $darkest;
        width: 15rem;

        &.stage {
            background: $red;
        }

        &.dev, 
        &.fe {
            background: $blue;
        }

        nav {
            transition: all 300ms ease-in-out;
            width: 15rem;

            a {
                height: 60px;
            }

            > .logo {
                display: block;
                margin: 3.5rem 0 1rem;
                text-align: center;
                transition: none;

                .logoBig {
                    height: 29px;
                }

                .logoSmall {
                    display: none;
                }
            }

            > ul {
                > li {
                    display: block;
                    padding: 0.75rem 0;

                    > a {
                        color: $lightest;

                        i {
                            width: 20px;
                            text-align: center;
                        }

                        .selection {
                            transition: all 300ms ease-in-out;
                            display: inline-block;
                            margin-right: 1.2rem;
                        }

                        &.active {
                            @extend .bold;
                            padding-left: 0;

                            .selection {
                                display: inline-block;
                                vertical-align: middle;
                                width: 0.35rem;
                                height: 1.75rem;
                                border-top-right-radius: 5rem;
                                border-bottom-right-radius: 5rem;
                                background-color: $brand;
                                margin-right: calc(1.2rem - 6px);
                            }
                        }

                        &:active, &:focus {
                            color: $lightest;
                            text-decoration: none;
                        }
                    }
                }
            }
        }

        .bottomInfoSmall{
            display: none;
        }
    }

    aside.collapsed {
        width: 4.7rem;

        nav {
            .logo {
                width: 4.5rem;

                .logoCanvas {
                    width: 48px;
                    overflow: hidden;
                    padding-left: 4px;
                    display: inline-block;

                    .logoBig {
                        height: 41px;
                    }
                }
            }

            ul {
                li {
                    a{ 
                        .selection {
                            margin-right: 1.4rem;
                        }

                        &.active {
                            .selection {
                                margin-right: calc(1.4rem - 6px);
                            }
                        }

                        .label {
                            display: none;
                            white-space: nowrap;
                        }
                    }
                }
            }
        }

        .bottomInfoBig {
            display: none;
        }

        .bottomInfoSmall {
            display: inline-block;
        }
    }

    .newItemLabel {
        position: absolute;
        bottom: -15px;
        left: -5px;
        padding: 2px 4px;
        border-radius: 5px;
        line-height: 0.9em;
    }

    .overflow-visible {
        overflow: visible;
    }

    .no-break-label {
        white-space: nowrap;
    }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?63770310